import { Controller } from "@hotwired/stimulus"

// 다음 우편번호 API 주소 검색 컨트롤러
export default class extends Controller {
  static targets = ["address"]

  search(event) {
    event.preventDefault()

    // daum.Postcode가 로드되어 있는지 확인
    if (typeof daum === 'undefined' || typeof daum.Postcode === 'undefined') {
      alert('주소 검색 서비스를 로드하는 중입니다. 잠시 후 다시 시도해주세요.')
      return
    }

    new daum.Postcode({
      oncomplete: (data) => {
        // 도로명 주소 우선, 없으면 지번 주소 사용
        let address = data.roadAddress || data.jibunAddress

        // 건물명이 있으면 추가
        if (data.buildingName) {
          address += ` (${data.buildingName})`
        }

        this.addressTarget.value = address
        this.addressTarget.focus()
      }
    }).open()
  }
}
